import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/react";
import { loadCdnFonts } from "./lib/cdn";
import "./styles.css";
import { restoreDeletionCapability } from "./lib/deletionCapability";

void loadCdnFonts();

const root = createRoot(document.getElementById("root")!);
if (window.location.pathname === "/account-deletion") {
  // Keep email capabilities away from third-party SDKs, including Clerk.
  const capability = restoreDeletionCapability();
  void import("./pages/AccountDeletion").then(({ default: AccountDeletion }) => root.render(<StrictMode><AccountDeletion capability={capability} /></StrictMode>));
} else if (import.meta.env.DEV && window.location.pathname === "/__preview") {
  void import("./test/VisualPreview").then(({ default: VisualPreview }) => root.render(<StrictMode><VisualPreview /></StrictMode>));
} else {
  const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
  void import("./App").then(({ default: App, PublicApp }) => root.render(<StrictMode>{publishableKey ? <ClerkProvider
    publishableKey={publishableKey}
    signInUrl="https://auth.kitsos.net/sign-in"
    signUpUrl="https://signup.kitsos.net"
    signInFallbackRedirectUrl="https://myaccount.kitsos.net"
    signUpFallbackRedirectUrl="https://myaccount.kitsos.net"
    allowedRedirectOrigins={[/^https:\/\/(?:[a-z0-9-]+\.)*kitsos\.net$/i]}
    afterSignOutUrl="https://kitsos.net"
  ><App /></ClerkProvider> : <PublicApp/>}</StrictMode>));
}
